import { useState } from 'react';
import { Form, Button, Container } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import BACKEND_URL from '../config';
import './ResetPasswordForm.css';

const ResetPasswordForm = () => {
    const { token } = useParams(); // Extract the token from the URL
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate password and confirm password
        if (newPassword !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        try {
            // Make a POST request to the backend
            const response = await axios.post(`${BACKEND_URL}/api/reset-password/${token}`, {
                new_password: newPassword,
            });

            if (response.data.success) {
                setMessage('Password reset successfully. Redirecting to login...');
                setError('');
                setTimeout(() => navigate('/tms/login'), 3000); // Redirect to login after 3 seconds
            } else {
                setError(response.data.message || 'Failed to reset password');
            }
        } catch (err) {
            console.error(err);
            setError(err.response?.data?.message || 'An error occurred while resetting the password');
        }
    };

    return (
        <main className="reset-password-page">
            <Container className="reset-password-container">
                <h1>Reset Your Password</h1>

                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="newPassword" className="reset-password-form-group">
                        <Form.Label>New Password</Form.Label>
                        <Form.Control
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Form.Group controlId="confirmPassword">
                        <Form.Label>Confirm Password</Form.Label>
                        <Form.Control
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                    </Form.Group>

                    {message && <div className="success-message">{message}</div>}
                    {error && <div className="error-message">{error}</div>}

                    <Button variant="primary" type="submit" className="submit-button">
                        Reset Password
                    </Button>
                </Form>
            </Container>
        </main>
    );
};

export default ResetPasswordForm;
